import { render } from "./FormText.vue?vue&type=template&id=2034b18e"
import script from "./FormText.vue?vue&type=script&setup=true&lang=js"
export * from "./FormText.vue?vue&type=script&setup=true&lang=js"

import "./FormText.vue?vue&type=style&index=0&id=2034b18e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Atoms/FormText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2034b18e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2034b18e', __exports__)) {
    api.reload('2034b18e', __exports__)
  }
  
  module.hot.accept("./FormText.vue?vue&type=template&id=2034b18e", () => {
    api.rerender('2034b18e', render)
  })

}


export default __exports__